import $ from 'jquery'
import 'owl.carousel2'
import 'owl.carousel2.thumbs'

$(document).ready(function () {
  $('.productGallery .owl-carousel').owlCarousel({
    items: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    autoplayHoverPause: true,
    loop: $('.productGallery .item').length > 1,
    margin: 0,
    nav: true,
    mouseDrag: $('.productGallery .item').length > 1,
    touchDrag: $('.productGallery .item').length > 1,
    dots: true,
    thumbs: false,
    thumbsRenreder: false,
    navText: [
      '<i class="fas fa-chevron-left"></i>',
      '<i class="fas fa-chevron-right"></i>',
    ],
  })
})
